export enum OsVersionSoletenantCode {
    W10E='W10E',
    W7E='W7E',
    WS2019='WS2019',
    WS2016='WS2016'
 }